/* eslint-disable react/jsx-no-bind */
import React, {
  useContext, useEffect, useRef, useState,
} from 'react';
import Image from 'next/image';
import { Modal } from '@madeeasy/universal-login';
import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';
import { usePathname, useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';
import CallbackImage from '../../../public/assets/callbackFrame.svg';
import CREATE_COUNSELLING from '../../gql/mutations/counselling.gql';
import { ToastContext } from '../../contexts/toast-context-with-provider';
import { useUser } from '../../contexts/ssr-user-context';
import { domainBaseUrl } from '../../utils/helpers';
import { buildUtmMutationPayload } from '../../utils/marketing-attribution';

export default function CallBackCard({ entityId, entityType }) {
  const { user } = useUser();

  const isLoggedIn = user?.id;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();
  const { slug } = router.query;
  const [showLogin, setShowLogin] = useState(false);
  function toggleModal() {
    setShowLogin(false);
  }
  const pendingEnrollRef = useRef(false);
  const handleRedirect = () => {
    const slugPath = Array.isArray(slug) ? slug.join('/') : slug;
    const prepPath = ['PROD', 'PREPROD'].includes(process.env.NEXT_PUBLIC_HOME_REMOTE_CONFIG_ENV) ? '' : '/prep';
    const encodeUrl = encodeURIComponent(`${domainBaseUrl()}${prepPath}/${slugPath}`);
    const params = new URLSearchParams(searchParams.toString());
    params.set('redirectTo', encodeUrl);
    const newUrl = `${pathname}?${params.toString()}`;
    window.history.replaceState(null, '', newUrl);
    pendingEnrollRef.current = true;
  };

  const [createCounselling, { loading: mutationLoading, error: mutationError }] = useMutation(CREATE_COUNSELLING);
  const { showToast } = useContext(ToastContext);
  const callRequestCallBack = async () => {
    try {
      const utmData = buildUtmMutationPayload();
      const {
        utmMedium, utmSource, utmCampaign, utmTerm, gclid: gclId,
      } = utmData || {};
      const result = await createCounselling({
        variables: {
          input: {
            entityId,
            entityType,
            utmMedium: utmMedium ?? '',
            utmSource: utmSource ?? '',
            utmCampaign: utmCampaign ?? '',
            utmTerm: utmTerm ?? '',
            gclId: gclId ?? '',
          },
        },
      });
      if (result) {
        showToast('Counselling request submitted successfully!');
      }
    } catch (err) {
      if (err) {
        console.error('Mutation error:', mutationError);
      }
    }
  };

  const handleClick = async () => {
    if (!isLoggedIn) {
      handleRedirect();
      setShowLogin(true);
    } else {
      callRequestCallBack();
    }
  };

  useEffect(() => {
    const handleLoginSuccess = () => {
      if (pendingEnrollRef.current) {
        callRequestCallBack();
        pendingEnrollRef.current = false;
      }
    };

    window.addEventListener('loginSuccess', handleLoginSuccess);

    return () => {
      window.removeEventListener('loginSuccess', handleLoginSuccess);
    };
  }, []);
  return (
    <div className="w-full h-[372px] bg-[#C4E2FF30] px-4 py-6 border border-[#D0EEFF]">
      <div className="flex flex-col items-center max-w-md text-center">
        <div className="mb-6">
          <Image
            src={CallbackImage}
            alt="Call back illustration"
            width={278}
            height={139}
            className="rounded-md"
          />
        </div>

        <p className="text-xl font-semibold text-gray-900">
          We are here to guide you!
        </p>

        <p className="text-gray-600 mt-1 text-[18px]">
          Raise your enquiry and
          {' '}
          <br />
          {' '}
          get callback.
        </p>

        <button type="button" className="mt-6 bg-[#0267b1] hover:bg-[#025a99] text-white font-medium px-10 py-2" onClick={handleClick}>
          Request a Call Back
          {
            mutationLoading && <span className="ml-2 animate-spin">...</span>
          }
        </button>
      </div>
      {showLogin ? <Modal toggleModal={toggleModal} text="Login" /> : null}
    </div>
  );
}

CallBackCard.propTypes = {
  entityId: PropTypes.string.isRequired,
  entityType: PropTypes.string.isRequired,
};
